// extracted by mini-css-extract-plugin
export default {"logo":"top_logo__JK24q","logo_placeholder":"top_logo_placeholder__vVmnJ"};